var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  viewBox: "0 0 16 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 4.541v7.834c0 .894-.72 1.625-1.6 1.625H1.6C.72 14 0 13.269 0 12.375l.005-7.32 7.592 4.82L16 4.541zM14.4 0c.88 0 1.6.731 1.6 1.625v1.496L7.597 8.455.006 3.636l.002-2.011C.008.781.643.082 1.455.007L1.6 0z"
})));
export default SvgIconEmail;